import { Link } from 'react-router-dom';
import { Minus, Plus, Store, ArrowRight } from 'lucide-react';
import { useCart } from '../lib/cart';

const rs = (n) => `₹${Number(n).toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;

export default function IndiaCartSection() {
  const cart = useCart();
  const groups = cart.india.reduce((m, i) => ((m[i.store.id] = m[i.store.id] || { store: i.store, items: [] }).items.push(i), m), {});
  return (
    <section data-testid="india-cart" className="space-y-4">
      <div>
        <h1 className="font-heading font-black text-3xl md:text-4xl">BharatCart bag</h1>
        <p className="text-sm text-ink/60">{Object.keys(groups).length} seller{Object.keys(groups).length === 1 ? '' : 's'} · one order is created for each seller, who ships it to you.</p>
      </div>
      {Object.values(groups).map(g => (
        <div key={g.store.id} className="card-soft p-4 space-y-3" data-testid={`india-cart-seller-${g.store.id}`}>
          <div className="font-semibold flex items-center gap-2"><Store className="w-4 h-4 text-[#D35400]"/>Sold by {g.store.name}</div>
          {g.items.map(i => (
            <div key={i.product.id} className="flex items-center gap-3">
              <img src={i.product.image_url} alt="" className="w-14 h-14 rounded-lg object-cover bg-white border border-border"/>
              <Link to={i.product.slug ? `/p/${i.product.slug}` : '#'} className="flex-1 text-sm font-medium hover:underline">{i.product.name}</Link>
              <div className="flex items-center gap-1">
                <button data-testid={`india-qty-minus-${i.product.id}`} onClick={() => cart.indiaSetQty(i.product.id, i.qty - 1)} className="w-8 h-8 rounded-full border border-border grid place-items-center"><Minus className="w-3.5 h-3.5"/></button>
                <span data-testid={`india-qty-${i.product.id}`} className="w-6 text-center text-sm font-bold">{i.qty}</span>
                <button data-testid={`india-qty-plus-${i.product.id}`} disabled={i.qty >= (i.product.stock || 99)} onClick={() => cart.indiaSetQty(i.product.id, i.qty + 1)} className="w-8 h-8 rounded-full border border-border grid place-items-center disabled:opacity-40"><Plus className="w-3.5 h-3.5"/></button>
              </div>
              <span className="w-24 text-right font-semibold">{rs(i.product.price * i.qty)}</span>
            </div>
          ))}
        </div>
      ))}
      <div className="flex flex-wrap items-center justify-between gap-3 rounded-xl bg-[#FFF8EE] border border-[#E67E22]/30 p-4">
        <div><div className="text-sm text-ink/60">Items total (delivery & offers applied at checkout)</div><div data-testid="india-cart-subtotal" className="font-heading font-black text-2xl">{rs(cart.totals.indiaSubtotal)}</div></div>
        <Link to="/checkout/india" data-testid="india-checkout-btn" className="btn-primary">Checkout <ArrowRight className="w-4 h-4"/></Link>
      </div>
    </section>
  );
}
